export const AnalysisSection = (props) => {
    const headline = props.headline || "Real-time analysis";
    const subHeading = props.subHeading;
    const analysers = props.analysers || [];
    return (<section className="atf-section-padding">
              <div className="container">
                  <div className="row justify-content-center clearfix">
                      <div className="col-lg-7 col-12 d-block d-lg-none text-center align-self-center">
                          <div>
                              <h2 className="heading-size" style={{ color:"var(--thm-black)"}}>{headline}</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "5px 0 0px 0"  }}>{subHeading}</p>
                              
                          </div>
                      </div>
                      <div className="col-lg-6 col-12 text-center pt-3">
                            <div className="container">
                                <div className="row justify-content-center clearfix text-center align-self-center">
                                    {analysers.map((analyser, index) => {
                                        let mobileSize = 'col-4';
                                        mobileSize = index < 3 ? 'col-6' : mobileSize;
                                        mobileSize = index < 1 ? 'col-12' : mobileSize;

                                        return (
                                            <div key={index} className={`col-lg-3 ${mobileSize} p-1 ${analyser.showLg === false ? 'd-lg-none' : ''}`}>
                                                <img src={`${analyser.src}`} alt={analyser.caption} ></img>
                                                <div className="caption-text">{analyser.caption}</div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>      
                                                                
                      </div>
                      <div className="col-lg-6 col-12  d-none d-lg-block text-center align-self-center">
                          <div>
                              <h2 className="heading-size" style={{ color:"var(--thm-black)"}}>{headline}</h2>
                              <p style={{ fontSize: "18px", lineHeight: "1.7", margin: "5px 0 0px 0"  }}>{subHeading}</p>
                              <p style={{ fontSize: '16px', lineHeight: "1.7", margin: "25px 0 0px 0"  }}>{analysers.map(analyser => analyser.caption).join(' • ')}</p>
                          </div>
                      </div>
                  </div>
              </div>
          </section>
    
    );
}

export default AnalysisSection;